
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"storeShipping"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StoreShipping"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"threshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"costBelowThreshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"costAboveThreshold"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":105}};
    doc.loc.source = {"body":"fragment storeShipping on StoreShipping {\n  cost\n  threshold\n  costBelowThreshold\n  costAboveThreshold\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
